import { CdrColorTextPrimary as o, CdrColorTextLinkRest as r, CdrColorTextBrand as n, CdrColorTextInverse as a, CdrColorTextSale as d, CdrColorTextSecondary as l, CdrColorBackgroundPrimary as b, CdrColorBackgroundSecondary as c, CdrColorBackgroundMessageSale as s, CdrColorBackgroundBrandSpruce as y } from "@rei/cdr-tokens";
const t = {
  contentPalettes: {
    primary: {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: r,
      accentText: n,
      altLink: r,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    inverse: {
      eyebrow: a,
      heading: a,
      subheading: a,
      body: a,
      inlineLink: a,
      accentText: a,
      altLink: a,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "dark-secondary"
    },
    sale: {
      eyebrow: o,
      heading: d,
      subheading: d,
      body: o,
      inlineLink: r,
      accentText: d,
      altLink: r,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    },
    "sale-inverse": {
      eyebrow: a,
      heading: a,
      subheading: a,
      body: a,
      inlineLink: a,
      accentText: a,
      altLink: a,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "sale"
    },
    brand: {
      eyebrow: o,
      heading: n,
      subheading: n,
      body: o,
      inlineLink: r,
      accentText: n,
      altLink: r,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    "brand-inverse": {
      eyebrow: a,
      heading: a,
      subheading: a,
      body: a,
      inlineLink: a,
      accentText: a,
      altLink: a,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "inverse-secondary"
    },
    "alt-sale": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: r,
      accentText: l,
      altLink: r,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    }
  },
  surfacePalettes: {
    primary: {
      background: b,
      backgroundHover: c
    },
    secondary: {
      background: c,
      backgroundHover: c
    },
    sale: {
      background: s,
      backgroundHover: s
    },
    brand: {
      background: y,
      backgroundHover: y
    },
    dark: {
      background: "#0c0b08bf",
      backgroundHover: "#0c0b08bf"
    }
  }
}, k = (i = { content: "primary", surface: "primary" }) => ({
  cssSurfacePaletteVars: () => {
    const e = t.surfacePalettes[i.surface];
    return {
      "--palette-background-color": e == null ? void 0 : e.background,
      "--palette-background-hover-color": e == null ? void 0 : e.backgroundHover
    };
  },
  /*
  * These can be imported for sections that dont use content block but still need
  * content palette applied.
  */
  paletteCtaModifiers: () => {
    const e = t.contentPalettes[i.content];
    return {
      primaryCtaModifier: e.primaryCtaModifier,
      secondaryCtaModifier: e.secondaryCtaModifier
    };
  },
  cssContentPaletteVars: () => {
    const e = t.contentPalettes[i.content];
    return {
      "--palette-eyebrow-color": e == null ? void 0 : e.eyebrow,
      "--palette-heading-color": e == null ? void 0 : e.heading,
      "--palette-subheading-color": e == null ? void 0 : e.subheading,
      "--palette-body-color": e == null ? void 0 : e.body,
      "--palette-inline-link-color": e == null ? void 0 : e.inlineLink,
      "--palette-accent-text-color": e == null ? void 0 : e.accentText,
      "--palette-alt-link-color": e == null ? void 0 : e.altLink
    };
  }
});
export {
  k as palettes
};
